import { createAsyncThunk } from "@reduxjs/toolkit";
import { initialHistoryPoints } from "@store/slices/loyaltyCoreSlice";

import { getUser, LoyaltyApi } from "@jti/rest-api";
import { type CustomerPointsHistoryResponseType } from "@jti/rest-api-types";

type FetchPointsHistoryPayload = { perPage: number; pageNo: number };

export const fetchPointsHistory = createAsyncThunk<
  CustomerPointsHistoryResponseType & { isLoaded: boolean },
  FetchPointsHistoryPayload,
  { rejectValue: { message: string; code: number } }
>("loyaltyCore/fetchPointsHistory", async ({ perPage, pageNo }, { rejectWithValue }) => {
  const loyaltyApi = LoyaltyApi.init();
  const user = getUser();
  if (user?.uuid && user?.ciam_token && perPage && pageNo) {
    try {
      const result = await loyaltyApi.getPointsHistory(user.uuid, user.ciam_token, perPage, pageNo);
      return { ...result, isLoaded: true };
    } catch (error) {
      if (typeof error === "object" && error !== null) {
        const { message, statusCode } = error as Record<string, unknown>;

        if (typeof message === "string" && typeof statusCode === "number") {
          return rejectWithValue({ message, code: statusCode });
        }
      }
      return rejectWithValue({ message: "An unknown error occurred", code: 0 });
    }
  }

  return initialHistoryPoints;
});
